import { Controller } from 'stimulus';
const TomSelect = require('../lib/tom_select');

export default class extends Controller {
  static targets = ['container', 'template']

  add(e) {
    e.preventDefault();
    const content = this.templateTarget.innerHTML;
    const index = new Date().getTime();
    this.containerTarget.insertAdjacentHTML(
      'beforeend',
      content.replace(/NEW_INDEX/g, index)
    );
    this.initSelect2(this.containerTarget.lastElementChild);
  }

  remove(e) {
    e.preventDefault();
    e.target.closest('.training-item-row').remove();
  }

  toggleType(e) {
    const row = e.target.closest('.training-item-row');
    const value = e.target.value;

    row.querySelectorAll('[data-type-match]').forEach((el) => {
      if (el.dataset.typeMatch === value) {
        el.classList.remove('hidden');
        el.querySelectorAll('input,select').forEach((input) => {
          input.removeAttribute('disabled');
        });
      } else {
        el.classList.add('hidden');
        el.querySelectorAll('input,select').forEach((input) => {
          input.setAttribute('disabled', 'disabled');
        });
      }
    });
  }

  changeTrainingRecord(e) {
    const row = e.target.closest('.training-item-row');
    const selected = e.target.options[e.target.selectedIndex];
    const documentId = selected ? selected.dataset.documentId : null;
    const revisionWrapper = row.querySelector('[data-role="existing-revision-wrapper"]');

    if (!revisionWrapper) return;

    if (documentId) {
      revisionWrapper.classList.remove('hidden');
      const revisionSelect = revisionWrapper.querySelector('[data-role="existing-revision-select"]');
      revisionSelect.removeAttribute('disabled');

      let firstMatch = null;
      revisionSelect.querySelectorAll('option[data-document-id]').forEach((opt) => {
        if (opt.dataset.documentId === documentId) {
          opt.style.display = '';
          if (!firstMatch) firstMatch = opt;
        } else {
          opt.style.display = 'none';
        }
      });
      revisionSelect.value = firstMatch ? firstMatch.value : '';
    } else {
      revisionWrapper.classList.add('hidden');
      const revisionSelect = revisionWrapper.querySelector('[data-role="existing-revision-select"]');
      revisionSelect.value = '';
    }
  }

  changeDocument(e) {
    const row = e.target.closest('.training-item-row');
    const documentId = e.target.value;
    const revisionSelect = row.querySelector('[data-role="new-document-revision-select"]');

    if (!revisionSelect) return;

    let firstMatch = null;
    revisionSelect.querySelectorAll('option[data-document-id]').forEach((opt) => {
      if (opt.dataset.documentId === documentId) {
        opt.style.display = '';
        if (!firstMatch) firstMatch = opt;
      } else {
        opt.style.display = 'none';
      }
    });

    revisionSelect.value = firstMatch ? firstMatch.value : '';
  }

  initSelect2(row) {
    row.querySelectorAll('[data-controller="select2"]').forEach((el) => {
      if (!el.tomselect) {
        new TomSelect(el, {
          plugins: ['clear_button'],
          searchConjunction: 'and',
        });
      }
    });
  }
}
